export const REMOVE_BUTTON_SMALL_TEXT = {
    id: 'oe.connections.remove.button.small',
    description: 'Small remove connection button',
    defaultMessage: 'Remove',
};

export const INPUT_CONNECTIONS_TEXT = {
    id: 'oe.input.connections',
    description: 'Input label',
    defaultMessage: 'Connections',
};

export const INPUT_DEFAULT_TEXT = {
    id: 'oe.input.default',
    description: 'Default label',
    defaultMessage: 'Default'
};

export const CONNECTIONS_SETTINGS_TEXT = {
    id: 'oe.connections.settings',
    description: 'Label',
    defaultMessage: 'Settings'
};

export const FLYOUT_TABS_CONNECTION_LABEL_TEXT = {
    id: 'oe.templates.connection.label',
    defaultMessage: 'Flyout Tabs',
    description: 'Label text'
};

export const NEVERLATE_ENABLED_CONNECTION_LABEL_TEXT = {
    message: 'NeverLate® navigation is {postfix}',
    id: 'oe.common.neverlateEnabled',
    description: 'Label text',
};

export const PUBLISHED_ENABLED_CONNECTION_LABEL_TEXT = {
    message: 'Connection is {postfix}',
    id: 'oe.common.publishedEnabled',
    description: 'Label text',
};

export const PASSPORT_REPLAY_ENABLED_CONNECTION_LABEL_TEXT = {
    message: 'Passport Replay is {postfix}',
    id: 'oe.common.passportReplayEnabled',
    description: 'Label text',
};

export const ZOOM_AUTO_REGISTRATION_ENABLED_CONNECTION_LABEL_TEXT = {
    message: 'Auto Registration is {prefix}',
    id: 'oe.common.zoomAutoRegistrationEnabled',
    description: 'Label text',
};

export const ZOOM_SYNC_ENABLED_CONNECTION_LABEL_TEXT = {
    message: 'Auto Sync is {prefix}',
    id: 'oe.common.zoomSyncEnabled',
    description: 'Label text',
};

export const ZOOM_REGISTRATION_ENABLED_CONNECTION_LABEL_TEXT = {
    message: 'Registration is {prefix}',
    id: 'oe.common.zoomRegistrationEnabled',
    description: 'Label text',
};

export const ZOOM_APPROVAL_TYPE_CONNECTION_LABEL_TEXT = {
    message: 'Automatic Approval is {prefix}',
    id: 'oe.common.zoomApprovalType',
    description: 'Label text',
};

export const ZOOM_REGISTRANTS_CONFIRMATION_EMAIL_CONNECTION_LABEL_TEXT = {
    message: 'Zoom Registration Emails is {prefix}',
    id: 'oe.common.zoomRegistrantsConfirmationEmail',
    description: 'Label text',
};

export const ZOOM_CONNECTION_DUPLICATE_ERROR_TEXT = {
    message: 'You cannot add two Zoom/Webinar connections with Auto Sync enabled',
    id: 'oe.connections.zoom.zoomConnectionDuplicateError',
    description: 'Label text',
};

export const EXPIRATION_DATE_IS_SET_TEXT = {
    message: 'Expiration date is set',
    id: 'oe.connections.knovio.expirationDateIsSet',
    description: 'Label text',
};

export const NO_EXPIRATION_DATE_IS_SET_TEXT = {
    message: 'No expiration is set',
    id: 'oe.connections.knovio.noExpirationDateIsSet',
    description: 'Label text',
};

export const EXPIRATION_DATE_WILL_BE_SET_TEXT = {
    id: 'oe.connections.knovio.expirationDateWillBeSet',
    defaultMessage: 'Expiration date will be set to',
    description: 'Label text'
};

export const DAYS_COUNT_BEFORE_EXPIRATION_TEXT = {
    id: 'oe.connections.knovio.daysCountBeforeExpiration',
    defaultMessage: '{prefix} days after meeting date',
    description: 'Label text'
};

export const ZOOM_AUTOMATICALLY_RECORD_CONNECTION_LABEL_TEXT = {
    message: 'Automatically Record is {prefix}',
    id: 'oe.common.zoomAutomaticallyRecord',
    description: 'Label text',
};

export const ZOOM_PANELIST_LINK_CREATION_ENABLED_CONNECTION_LABEL_TEXT = {
    message: 'Panelist link creation {prefix}',
    id: 'oe.common.zoomPanelistLinkCreationEnabled',
    description: 'Label text',
};

export const ZOOM_PANELIST_LINK_CREATION_ENABLED_INFO_TEXT = {
    id: 'oe.common.zoomPanelistLinkCreationEnabled.info',
    defaultMessage: 'When enabled a panelist link will be created for all presenters and hosts on the meeting.',
    description: 'Info text for panelist link creation toggle',
};